import React, { FunctionComponent, ReactNode } from 'react'
import MaskedInput from 'react-text-mask'
import classnames from 'classnames'

import { StartAdornment, START_ADORNMENT_INPUT_CLASS } from './startAdornment'

export type Callback<T = void> = (...args: any) => T

interface Input {
  name: string
}

interface Meta {
  error: string
  submitFailed: boolean
}

export interface Props {
  label: string
  input: Input
  meta: Meta
  mask?: string[] | Callback
  pipe?: Callback
  gridClass?: string
  className?: string
  endAdornment?: ReactNode
  startAdornment?: ReactNode
  fieldError?: string
}

const InputField: FunctionComponent<Props> = ({
  label,
  input,
  meta,
  mask,
  pipe,
  gridClass,
  className,
  endAdornment,
  startAdornment,
  fieldError,
  ...rest
}) => {
  const { submitFailed, error } = meta

  return (
    <div
      className={classnames('form__group', {
        [`${gridClass}`]: gridClass,
      })}
    >
      {label && (
        <label className="form__label" htmlFor={input.name}>
          {label}
        </label>
      )}

      <div style={{ position: 'relative' }}>
        {startAdornment && <StartAdornment>{startAdornment}</StartAdornment>}
        {mask || pipe ? (
          <MaskedInput
            id={input.name}
            mask={mask as any}
            pipe={pipe as any}
            {...input}
            {...rest}
            className={classnames('form__control', className, {
              'form__control--error': !!fieldError || (submitFailed && error),
              [START_ADORNMENT_INPUT_CLASS]: !!startAdornment,
            })}
          />
        ) : (
          <input
            id={input.name}
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
            {...input}
            {...rest}
            className={classnames('form__control', className, {
              'form__control--error': submitFailed && error,
              [START_ADORNMENT_INPUT_CLASS]: !!startAdornment,
            })}
          />
        )}
        {endAdornment && (
          <div style={{ position: 'absolute', top: '4px', right: '4px' }}>
            {endAdornment}
          </div>
        )}
      </div>
      {fieldError && <p className="form__help-text text-error">{fieldError}</p>}
      {submitFailed && error && (
        <p className="form__help-text text-error">{error}</p>
      )}
    </div>
  )
}

export default InputField
